module.exports = __webpack_public_path__ + "img/slack.058bf664.svg";